import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M38 8h1c1.258 0 2.47.333 3.533.956a7.03 7.03 0 0 1 2.51 2.51A6.97 6.97 0 0 1 46 15q-.039 5.039 0 12.012.027 4.765-.443 9.993a7 7 0 0 1-6.493 6.357q-9.82.674-15.013.674-5.198 0-15.098-.675a7 7 0 0 1-6.496-6.37Q2 31.8 2 27.017V15c0-1.258.333-2.47.956-3.534a7.03 7.03 0 0 1 2.51-2.51A6.97 6.97 0 0 1 9 8h1V7a3 3 0 0 1 6 0v1h16V7a3 3 0 1 1 6 0zm-.171 2a3.001 3.001 0 0 1-5.659 0H15.83a3.001 3.001 0 0 1-5.66 0H9c-.9 0-1.764.238-2.523.682a5.03 5.03 0 0 0-1.795 1.795A4.97 4.97 0 0 0 4 15v12.018q0 4.692.449 9.797a5 5 0 0 0 4.64 4.55c6.56.447 11.55.67 14.962.67q5.115 0 14.876-.669a5 5 0 0 0 4.638-4.54q.46-5.134.435-9.803a914 914 0 0 1 0-12.027c0-.899-.238-1.761-.682-2.519a5.03 5.03 0 0 0-1.795-1.795A4.97 4.97 0 0 0 39 10zm-2.83-4a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1M13 6a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1m-2 12a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V19a1 1 0 0 0-1-1zm26-2H11a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h26a3 3 0 0 0 3-3V19a3 3 0 0 0-3-3m-18 .594a1 1 0 0 0-1 1V26h-8a1 1 0 0 0 0 2h8v8.331a1 1 0 1 0 2 0v-8.33h8v8.33a1 1 0 0 0 2 0v-8.33h8a1 1 0 0 0 0-2h-8v-8.407a1 1 0 1 0-2 0V26h-8v-8.406a1 1 0 0 0-1-1",
      clipRule: "evenodd"
    }
  )
);
var SvgCalendarOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CalendarOutlined_default = SvgCalendarOutlined;

export { CalendarOutlined_default as default };
